export const skills = [
    {
        name: "Programming-languages",
        language: "Javascript (TypeScript)"
    }, 
    {
        name: "Other",
        language: "HTML, CSS, Bootstrap, Tailwind CSS, MUI, React Hooks, Redux Toolkit, DOM manipulasiyası, jQuery, Ajax, Fetch, Git, Github, FireBase, Google-Fu, Agile metodologiyası"
    },
    {
        name: "Tools",
        language: "VSCode WebStorm"
    },
    {
        name: "DataBases",
        language: "MongoDB - (beginner), FireBase"
    },
    {
        name: "Frameworks",
        language: "React, Next.js, Express.js - (beginner)"
    }
]